import InfoIcon from '@mui/icons-material/InfoOutlined';
import { Box, Box as MuiBox, Dialog, styled } from '@mui/material';
import { LabelSmallStyled } from 'v3/shared/typography/LabelSmall/styles';
import { TitleSmallStyled } from 'v3/shared/typography/TitleSmall/styles';
import { CustomIconProps } from './types';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.common.white}`,
    borderRadius: '0.375rem',
    gap: '1.5rem',
    width: '100%',
    maxWidth: '37.5rem',
    padding: '1.5rem',
    flexGrow: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '1.5rem',
    },
  },
}));

export const Icon = styled('img')(() => ({
  width: '9.5rem',
}));

export const Content = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1.5rem',
  paddingLeft: '1.5rem',
  paddingRight: '1.5rem',
  flexGrow: 1,
}));

export const ColumnStep = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  gap: '1.5rem',
  minHeight: 0,
  flexGrow: 1,
}));

export const RowStep = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'start',
  gap: '0.5rem',
  flexGrow: 1,
  minHeight: 0,
}));

export const StepNumber = styled(LabelSmallStyled)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.details.main,
  borderRadius: '50%',
  width: '1.5rem',
  height: '1.5rem',
  flexShrink: 0,
  color: theme.palette.primary.dark,
  textAlign: 'center',
}));

export const InfoBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: '0.5rem',
  gap: '0.75rem',
  padding: '0.75rem',
}));

export const IconStyled = styled(InfoIcon)<CustomIconProps>(({ customColor }) => ({
  color: customColor,
}));

export const TextOpacity = styled(TitleSmallStyled)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.green.dark,
}));

export const StyledButtonContainer = styled(Box)(({ theme }) => ({
  paddingTop: '0.5rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '1rem',
  },
}));
